import FrequentlyPurchasedProductsCarousel from './FrequentlyPurchasedProductsCarousel';
import { withI18n } from 'react-i18next';

import { connect } from 'react-redux';

import { analyticsActions } from 'src/analytics/store';

interface IDispatchFromProps {
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  fireProductImpressionEvent: (data: any) =>
    dispatch(analyticsActions.productImpression(data)),
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.productClick(data))
});

export default connect(
  null,
  mapDispatchToProps
)(withI18n()(FrequentlyPurchasedProductsCarousel));
